import {useLayoutEffect} from 'react';

export const usePreventScroll = (
    preventScroll: boolean,
    shouldHideOverflow: boolean,
) => {
    useLayoutEffect(() => {
        if (!preventScroll) {
            return;
        }

        if (
            shouldHideOverflow &&
            typeof window !== 'undefined' &&
            window.document
        ) {
            document.body.classList.add('u-overflow-y-hidden');
            document.documentElement.classList.add('u-overflow-y-hidden');
        }

        if (
            !shouldHideOverflow &&
            typeof window !== 'undefined' &&
            window.document
        ) {
            document.body.classList.remove('u-overflow-y-hidden');
            document.documentElement.classList.remove('u-overflow-y-hidden');
        }

        return () => {
            document.body.classList.remove('u-overflow-y-hidden');
            document.documentElement.classList.remove('u-overflow-y-hidden');
        };
    }, [preventScroll, shouldHideOverflow]);
};
